import { Box, Dialog, DialogActions, DialogContent, makeStyles } from '@material-ui/core';
import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { colors } from '../theme/colors';

const useStyles = makeStyles(() => ({
  root: {
    backdropFilter: 'blur(3px)',
    '& .MuiPaper-root': {
      width: 600,
      borderRadius: 30,
      boxShadow: '-2px -2px 8px rgba(0, 0, 0, 0.1), 6px 6px 8px rgba(0, 0, 0, 0.1)',
      backgroundColor: colors.xLightGray,
      paddingBottom: 55,
      paddingLeft: 55,
      paddingRight: 55,
      paddingTop: 20,
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
    },
    '&.MuiDialogContent-root': {
      padding: 0,
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'Center',
    },
  },
}));

type Props = {
  open: boolean;
  body: ReactNode;
  title: ReactNode;
  statusIcon: ReactNode;
  action: ReactNode;
};

export const AlertModal: FunctionComponent<Props> = (props) => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(props.open);

  useEffect(() => {
    setOpenModal(props.open);
  }, [props.open]);

  return (
    <div>
      <Dialog
        open={openModal}
        classes={{ root: classes.root }}
        data-testid="copy-referral-link-modal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            justifyContent="center"
            alignItems="center"
          >
            <Box marginBottom="30px">{props.statusIcon}</Box>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
              {props.title}
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            justifyContent="center"
            alignItems="center"
          >
            {props.body}
          </Box>
        </DialogContent>
        <DialogActions>{props.action}</DialogActions>
      </Dialog>
    </div>
  );
};
